import { useMsal } from "@azure/msal-react";
import React, { createContext, useContext, useState, useEffect } from "react";
import { getUserByUuid } from "../services/api/userService";
import Loader from "../components/ui/Loader";

const UserContext = createContext();

export const useUserContext = () => useContext(UserContext);

async function getUser(a, s) {
  try {
    const user = await getUserByUuid(a.localAccountId);
    s(user);
    return user;
  } catch (error) {
    console.error("Erreur lors de la récupération de l'utilisateur:", error);
  }
}

export const UserProvider = ({ children }) => {
  const { accounts, instance } = useMsal();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      if (accounts.length > 0) {
        const payload = JSON.parse(atob(accounts[0]?.idToken.split(".")[1]));
        const currentTime = Math.floor(Date.now() / 1000);

        if (payload.exp > currentTime) {
          await getUser(accounts[0], setUser);
        } else {
          instance.ssoSilent({
            scopes: ["openid", "profile"],
            prompt: "select_account",
          })
            .then(async (response) => {
              await getUser({ ...accounts[0], idToken: response.idToken }, setUser);
              window.location.reload();
            })
            .catch((error) => {
              console.error("Erreur lors du SSO Silent:", error);
              instance.loginRedirect({
                scopes: ["openid", "profile"],
              });
            });
        }
      }
      setIsLoading(false);
    };

    fetchUser();
    // eslint-disable-next-line
  }, [accounts]);

  if (isLoading) {
    return <Loader text="Chargement des données en cours... Merci de votre patience 😊" />;
  }

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {!isLoading && children}
    </UserContext.Provider>
  );
};
